module.exports = __webpack_public_path__ + "static/media/LaunchIcon.de3cacba.svg";